import {IComponentOptions} from 'angular';
import TSInspektorat from '../../../models/TSInspektorat';
import InspektoratRS from '../../../core/service/InspektoratRS.rest';
import {IStateService} from 'angular-ui-router';
import {IInspektoratStateParams} from '../../inspektoratverwaltung.route';
import RoleUtilService from '../../../core/service/RoleUtilService';
import {ApplicationPropertyRS} from '../../../admin/service/applicationPropertyRS.rest';
import ITranslateService = angular.translate.ITranslateService;

let template = require('./inspektoratverwaltungView.html');
require('./inspektoratverwaltungView.scss');

export class InspektoratverwaltungViewComponentConfig implements IComponentOptions {
    transclude: boolean = false;
    template: string = template;
    controller: any = InspektoratverwaltungViewController;
    controllerAs: string = 'vm';
    bindings: any = {
        inspektorat: '<',
    };
}

export class InspektoratverwaltungViewController {
    inspektorat: Array<TSInspektorat>;

    static $inject = ['InspektoratRS', '$state', 'RoleUtilService', '$translate', 'ApplicationPropertyRS'];

    /* @ngInject */
    constructor(private inspektoratRS: InspektoratRS, private $state: IStateService,
                private roleUtilService: RoleUtilService, private $translate: ITranslateService, private applicationPropertyRS: ApplicationPropertyRS) {
    }

    $onInit() {
    }


    public editInspektorat(inspektorat: TSInspektorat, event: any) {
        let params: IInspektoratStateParams;
        params = {createNew: false, inspektoratId: inspektorat.id, inspektorat: inspektorat};
        this.$state.go('inspektorat', params);
    }

    public addInspektorat() {
        let params: IInspektoratStateParams;
        params = {createNew: true, inspektoratId: '', inspektorat: undefined};
        this.$state.go('inspektorat', params);
    }

}



// WEBPACK FOOTER //
// ./src/app/inspektoratverwaltung/component/inspektoratverwaltungView/inspektoratverwaltungView.ts